import { render, staticRenderFns } from "./Dojo.vue?vue&type=template&id=397cdc47&"
import script from "./Dojo.vue?vue&type=script&lang=ts&"
export * from "./Dojo.vue?vue&type=script&lang=ts&"
import style0 from "./Dojo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports